<template>
  <el-dialog top="30vh" title="" :visible.sync="isCheckinDialog" :close-on-click-modal="false">
    <img v-if="checkinStatus === 1" class="header-bg" src="./img/header-bg.png" alt="" />
    <img v-else-if="checkinStatus === 3" class="header-bg" src="./img/header-bg-success.png" alt="" />
    <img v-else class="header-bg" src="" alt="" />
    <img v-if="checkinStatus === 1" class="header" src="./img/header.png" alt="" />
    <img v-else-if="checkinStatus === 2" class="header" src="./img/header-failed.png" alt="" />
    <img v-else class="header" src="./img/header-success.png" alt="" />
    <img class="close" @click="toggleCheckinDialog(false)" src="./img/close.png" alt="" />

    <div class="checkin" v-show="checkinStatus === 1">
      <div class="day">
        <span>{{ continuous }}</span
        >天
      </div>
      <div class="a">连续签到领好礼</div>
      <div class="b">已连续签到</div>
      <div class="c">
        <div :class="['list', index === continuous ? 'list-active' : '']" v-for="(item, index) in checkinList" :key="index">
          <div class="list-a">{{ item.ExpNum }}</div>
          <img class="list-b" :src="item.IsChecked ? require('./img/checked.png') : index === continuous ? require('./img/checking.png') : require('./img/check.png')" alt="" />
          <div class="list-c">{{ whichDay[index] }}</div>
        </div>
        <div :class="['list list-7', continuous === 6 ? 'list-active' : '']">
          <div class="list-a"><span>经验值</span>{{ checkinLast.ExpNum }}</div>
          <img class="list-b" :src="checkinLast.IsChecked ? require('./img/checked.png') : continuous === 6 ? require('./img/checking.png') : require('./img/check.png')" alt="" />
          <div class="list-c">第七天</div>
        </div>
      </div>
      <div class="d btn-active" @click="checkin()">立即签到</div>
      <div class="e">每日签到奖励可在-<span @click="toCheckinPage">我的页面</span>-<span @click="toCheckinPage">每日签到</span>-内查看</div>
    </div>
    <div class="check-failed" v-show="checkinStatus === 2">
      <img src="./img/checkin-failed.png" alt="" />
      <div class="a">签到失败</div>
      <div>可稍后在我的页面</div>
      <div>进入每日签到进行补签</div>
      <div class="btn" @click="toggleCheckinDialog(false)">我知道了</div>
    </div>
    <div class="check-success" v-show="checkinStatus === 3">
      <div class="day">
        <span>{{ continuous }}</span
        >天
      </div>
      <div class="a">连续签到领好礼</div>
      <div class="b">已连续签到</div>
      <div class="one-gift" v-if="checkinGift.length === 1">
        <img :src="checkinGift[0].icon ? checkinGift[0].icon : checkinRewardPic(checkinGift[0].reward_type)" alt="" />
        <div>
          今日签到获取
          <span>{{ checkinGift[0].title + (checkinGift[0].reward_type === 1 || checkinGift[0].reward_type === 2 ? checkinGift[0].quantity / 100 : checkinGift[0].quantity) }}</span>
        </div>
      </div>
      <div class="gifts" v-if="checkinGift.length > 1">
        <div class="list" v-for="(item, index) in checkinGift" :key="index">
          <img :src="item.icon ? item.icon : checkinRewardPic(item.reward_type)" alt="" />
          <div>{{ item.title + "x" + (item.reward_type === 1 || item.reward_type === 2 ? item.quantity / 100 : item.quantity) }}</div>
        </div>
      </div>
      <div class="btn" v-show="!isLottery" @click="toggleCheckinDialog(false)">我知道了</div>
      <div class="btn" v-show="isLottery" @click="toLottery">立即夺宝</div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { post } from "../../util/http";
export default {
  computed: {
    ...mapState(["userInfo", "appConfig", "isCheckinDialog"]),
  },
  props: {},

  data() {
    return {
      // visible: false,
      checkinList: [],
      checkinLast: {},
      continuous: 0,
      // isActive: false,
      isCheckedToday: false,
      checkinStatus: 3,
      checkinGift: [],
      whichDay: ["第一天", "第二天", "第三天", "第四天", "第五天", "第六天"],
      isLottery: false,
    };
  },
  created() {},
  destroyed() {},
  mounted() {
    this.getCheckinInfo();
  },
  methods: {
    ...mapMutations(["toggleLogin", "toggleCheckinDialog"]),

    toLottery() {
      this.$router.push("/lottery");
      // this.toggleCheckinDialog();
    },

    async getCheckinHistory() {
      const {
        data: { data },
      } = await post({
        url: "/api/checkin/getCheckinHistory",
      });
      let lastArray = data.CheckinHistory.pop();
      this.checkinGift = lastArray.RewardDesc;
      this.checkGiftHaveLottery(this.checkinGift);
      localStorage.setItem("checkinGift", JSON.stringify(this.checkinGift));
    },
    async getCheckinInfo() {
      const {
        data: { data },
      } = await post({
        url: "/api/checkin/getCheckinInfo",
      });
      this.checkinLast = data.CheckinDetails.pop();
      this.checkinList = data.CheckinDetails;
      this.continuous = data.Continuous;
      this.isCheckedToday = data.IsCheckedToday;
      this.isCheckedToday ? (this.checkinStatus = 3) : (this.checkinStatus = 1);
      if (this.isCheckedToday) {
        let obj = JSON.parse(localStorage.getItem("checkinGift"));
        console.log(obj, "obj");
        if (obj) {
          this.checkinGift = obj;
          this.checkGiftHaveLottery(this.checkinGift);
        } else {
          this.getCheckinHistory();
        }
      }
    },
    async checkin() {
      if (!this.userInfo.id) {
        this.toggleLogin();
        return;
      }
      if (this.isCheckedToday) {
        this.$message.error("今天已签到");
        return;
      }
      const { data } = await post({
        url: "/api/checkin/checkinToday",
      });
      if (data.status === 0) {
        this.checkinGift = data.data.RewardList;
        this.checkGiftHaveLottery(this.checkinGift);
        localStorage.setItem("checkinGift", JSON.stringify(this.checkinGift));
        console.log(this.checkinGift, "this.checkinGift");
        this.$message.success("签到成功");
        this.checkinStatus = 3;
        this.getCheckinInfo();
      } else {
        this.$message.error("签到失败");
        this.checkinStatus = 2;
      }
    },
    checkGiftHaveLottery(arr) {
      arr?.forEach((e) => {
        if (e.reward_type === 6) {
          this.isLottery = true;
        }
      });
    },
    toCheckinPage() {
      this.$router.push("/user-center/checkin");
      this.toggleCheckinDialog(false);
    },
    checkinRewardPic(type) {
      switch (type) {
        case 0:
          return require("@/assets/img/checkin/exp.png");
        case 1:
          return require("@/assets/img/checkin/falcon-coin.png");
        case 2:
          return require("@/assets/img/checkin/diamond.png");
        case 3:
          return require("@/assets/img/checkin/gift-live.png");
        case 4:
          return require("@/assets/img/checkin/card.png");
        case 5:
          return require("@/assets/img/checkin/prop.png");
        case 6:
          return require("@/assets/img/checkin/lucky.png");

        default:
          return require("@/assets/img/default/default_logo.png");
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    // height: 5.74rem;
  }
  .el-dialog {
    width: 3.7rem;
    // height: 4rem;
    border-radius: 0px 0px 0.16rem 0.16rem;
  }
}
.header {
  height: 0.62rem;
  position: absolute;
  top: -0.62rem;
}
.header-bg {
  height: 3.13rem;
  position: absolute;
  top: -2rem;
  z-index: -1;
}
.close {
  position: absolute;
  width: 0.32rem;
  bottom: -0.56rem;
  left: 0;
  right: 0;
  margin: 0 auto;
  cursor: pointer;
}
.day {
  position: absolute;
  right: 0.3rem;
  top: 0.24rem;
  font-weight: 600;
  color: #333333;
  font-size: 0.2rem;
  span {
    font-weight: 700;
    color: #ff9018;
    font-size: 0.48rem;
  }
}
.checkin {
  height: 400px;
  display: flex;
  flex-direction: column;
  padding: 0.2rem;
  position: relative;

  .a {
    font-weight: 400;
    font-size: 0.14rem;
    color: #ff9018;
  }
  .b {
    font-weight: 600;
    color: #333333;
    font-size: 0.24rem;
    margin-top: 0.05rem;
    margin-bottom: 0.24rem;
  }
  .c {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .list {
      background: #f4f4f4;
      border-radius: 0.05rem;
      width: 0.72rem;
      height: 0.8rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      padding-top: 0.08rem;
      padding-bottom: 0.04rem;
      margin-bottom: 0.14rem;
      position: relative;
      cursor: pointer;
      .list-a {
        font-size: 0.2rem;
        color: #333333;
        font-weight: 700;
      }
      .list-b {
        width: 0.28rem;
      }
      .list-c {
        font-size: 0.14rem;
        color: #999999;
      }
      .list-d {
        width: 0.28rem;
        position: absolute;
        top: -0.1rem;
        right: -0.05rem;
      }
    }
    .list-active {
      background: linear-gradient(340.94deg, #03a2fa 18.8%, #8dffd1 110.43%);
      .list-a {
        color: #ffffff;
      }
      .list-c {
        color: #ffffff;
      }
    }
    .list-7 {
      width: 1.58rem;
      padding: 0.17rem 0.1rem 0.12rem;
      align-items: flex-start;
      .list-a {
        span {
          font-weight: 400;
          font-size: 0.16rem;
          color: #666666;
        }
      }
      .list-b {
        width: 0.4rem;
        position: absolute;
        right: 0.05rem;
        bottom: 0.08rem;
      }
    }
  }
  .d {
    width: 3.3rem;
    height: 0.48rem;
    background: linear-gradient(108.02deg, #e2e4e4 0%, #d3d6da 62.15%);
    border-radius: 6px;
    color: #ffffff;
    font-weight: 500;
    font-size: 0.16rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-top: 0.1rem;
    margin-bottom: 0.15rem;
  }
  .btn-active {
    background: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
    box-shadow: 0px 4px 8px rgba(48, 185, 188, 0.2);
    cursor: pointer;
  }
  .e {
    font-size: 0.14rem;
    color: #999999;
    text-align: center;
    span {
      color: #02a8a2;
      cursor: pointer;
    }
  }
}

.check-failed {
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 0.28rem 0.2rem 0.3rem;
  font-size: 0.14rem;
  color: #999999;
  img {
    width: 1.22rem;
  }
  .a {
    font-weight: 600;
    font-size: 0.22rem;
    color: #333333;
  }
  .btn {
    width: 100%;
    height: 0.48rem;
    background: linear-gradient(108.02deg, #e2e4e4 0%, #d3d6da 62.15%);
    border-radius: 6px;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}
.check-success {
  // height: 350px;
  display: flex;
  flex-direction: column;
  padding: 0.2rem 0.2rem 0.3rem;
  .a {
    font-weight: 400;
    font-size: 0.14rem;
    color: #ff9018;
  }
  .b {
    font-weight: 600;
    color: #333333;
    font-size: 0.24rem;
    margin-top: 0.05rem;
    margin-bottom: 0.24rem;
  }
  .one-gift {
    text-align: center;
    font-size: 0.18rem;
    color: #999999;
    margin-bottom: 0.2rem;
    img {
      width: 1.22rem;
      border-radius: 1.22rem;
      margin-bottom: 0.05rem;
    }
    span {
      color: #02a8a2;
    }
  }
  .gifts {
    display: grid;
    grid-template-columns: repeat(auto-fit, 0.93rem);
    justify-content: center;
    grid-gap: 0.2rem;
    .list {
      width: 0.93rem;
      height: 1.25rem;
      background: #f4f4f4;
      border-radius: 0.06rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      padding: 0.22rem 0;
      color: #999999;
      font-size: 0.14rem;
      img {
        height: 0.4rem;
        margin-bottom: 0.08rem;
      }
    }
  }
  .btn {
    width: 100%;
    height: 0.48rem;
    background: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
    box-shadow: 0px 4px 8px rgba(48, 185, 188, 0.2);
    border-radius: 6px;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-top: 0.15rem;
  }
}
</style>
